import {
  getExternalCalendarEvent as _getExternalCalendarEvent,
  GetExternalCalendarEventPayload,
} from '@griply/services';
import { CalendarEventDetails } from '@griply/types';
import { httpsCallable } from 'firebase/functions';
import { getErrorReporter } from 'shared/services/error-tracking';

import { getFunctions } from './helpers';
import { externalCalendarSanitizer } from './helpers/external-calendar-sanitizer';

export const getExternalCalendarEvent = async (
  payload: GetExternalCalendarEventPayload,
): Promise<CalendarEventDetails | null> => {
  try {
    return await _getExternalCalendarEvent({
      functions: getFunctions(),
      httpsCallable,
      payload,
      sanitizeDetails: externalCalendarSanitizer.sanitizeDetails,
    });
  } catch (error: unknown) {
    getErrorReporter().captureException(error, {
      tags: { source: 'external-calendars-get-event' },
    });
    throw error;
  }
};
